export class UnauthenticatedError extends Error {
  constructor() {
    super('You are unauthorized to use ACE')
  }
}
